<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <div class="mb-6 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Crew &amp; machine association</h1>
      <p class="text-sm text-gray-600">Assign operators, supervisors, and helpers to machines. Primary operator is used as the default on reservations.</p>
    </div>
    <select class="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm" [(ngModel)]="filterStatus" (change)="load()">
      <option value="active">Active</option>
      <option value="inactive">Inactive</option>
      <option value="">All</option>
    </select>
  </div>

  <div class="mb-6 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
    <h2 class="mb-4 text-sm font-semibold uppercase tracking-wide text-gray-500">New assignment</h2>
    <form class="grid grid-cols-1 gap-3 md:grid-cols-3 lg:grid-cols-6 items-end" (ngSubmit)="assign()">
      <label class="text-sm">
        <span class="mb-1 block text-xs font-medium text-gray-500">Staff</span>
        <select class="w-full rounded-lg border border-gray-200 px-3 py-2" [(ngModel)]="form.staff_id" name="staff_id" required>
          <option value="">Select</option>
          <option *ngFor="let s of staff" [value]="s.id">{{ s.full_name }} — {{ s.employee_code }}</option>
        </select>
      </label>
      <label class="text-sm">
        <span class="mb-1 block text-xs font-medium text-gray-500">Machine</span>
        <select class="w-full rounded-lg border border-gray-200 px-3 py-2" [(ngModel)]="form.machine_id" name="machine_id" required>
          <option value="">Select</option>
          <option *ngFor="let m of machines" [value]="m.id">{{ m.machine_name }} ({{ m.machine_id }})</option>
        </select>
      </label>
      <label class="text-sm">
        <span class="mb-1 block text-xs font-medium text-gray-500">Role</span>
        <select class="w-full rounded-lg border border-gray-200 px-3 py-2" [(ngModel)]="form.role" name="role">
          <option value="operator">Operator</option>
          <option value="supervisor">Supervisor</option>
          <option value="helper">Helper</option>
        </select>
      </label>
      <label class="text-sm flex items-center gap-2 pb-2">
        <input type="checkbox" [(ngModel)]="form.is_primary" name="is_primary" />
        Primary
      </label>
      <label class="text-sm">
        <span class="mb-1 block text-xs font-medium text-gray-500">From</span>
        <input type="date" class="w-full rounded-lg border border-gray-200 px-3 py-2" [(ngModel)]="form.effective_from" name="effective_from" />
      </label>
      <button type="submit" class="rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700">Assign</button>
    </form>
  </div>

  <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
    <div *ngIf="loading" class="p-8 text-center text-gray-500">Loading…</div>
    <table *ngIf="!loading" class="min-w-full text-sm">
      <thead class="bg-gray-50 text-left text-gray-600">
        <tr>
          <th class="px-4 py-3">Staff</th>
          <th class="px-4 py-3">Machine</th>
          <th class="px-4 py-3">Role</th>
          <th class="px-4 py-3">Primary</th>
          <th class="px-4 py-3">Status</th>
          <th class="px-4 py-3 text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rows" class="border-t border-gray-100">
          <td class="px-4 py-3">
            <div>{{ r.staff_name }}</div>
            <div class="text-xs text-gray-400">{{ r.employee_code }} · {{ r.designation }}</div>
          </td>
          <td class="px-4 py-3">{{ r.machine_name }} <span class="text-xs text-gray-400">({{ r.machine_code }})</span></td>
          <td class="px-4 py-3 capitalize">{{ r.role }}</td>
          <td class="px-4 py-3">{{ r.is_primary ? 'Yes' : '—' }}</td>
          <td class="px-4 py-3 capitalize">{{ r.status }}</td>
          <td class="px-4 py-3 text-right whitespace-nowrap">
            <button mat-button color="primary" *ngIf="!r.is_primary && r.status === 'active'" (click)="setPrimary(r)">Make primary</button>
            <button mat-button *ngIf="r.status === 'active'" (click)="deactivate(r)">Deactivate</button>
            <button mat-button color="warn" (click)="remove(r)">Remove</button>
          </td>
        </tr>
        <tr *ngIf="!rows.length">
          <td colspan="6" class="px-4 py-8 text-center text-gray-500">No crew assignments yet.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
